import { render, staticRenderFns } from "./groupOwner.vue?vue&type=template&id=762e8882&scoped=true"
import script from "./groupOwner.vue?vue&type=script&lang=js"
export * from "./groupOwner.vue?vue&type=script&lang=js"
import style0 from "./groupOwner.vue?vue&type=style&index=0&id=762e8882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762e8882",
  null
  
)

export default component.exports